module.exports = __webpack_public_path__ + "static/media/020-teeth brushing.074c61c3.svg";